$(document).ready(function () {
    $("#secondary-nav-mobile-opener").on("click", function (e) {
        e.preventDefault();
        $(".menu-wrapper").slideToggle();
        $(this).find("i").toggleClass("fa-angle-down");
        $(this).find("i").toggleClass("fa-angle-up");
        $("body").toggleClass("menu-open");
    });

    $("a[data-secondary-nav-menu]").on("click", function (e) {
        e.preventDefault();
        var targetId = $(this).attr("data-secondary-nav-menu");
        $(targetId).slideToggle();
        $(this).find(".fa-stack-1x").toggleClass("fa-plus");
        $(this).find(".fa-stack-1x").toggleClass("fa-minus");
    });

    $(window).scroll(function () {
        var top = $(window).scrollTop();
        var openerPosition = 57 - top;
        if (openerPosition < 0) {
            openerPosition = 0;
        }
        var wrapperPosition = 117 - top;
        if (wrapperPosition < 57) {
            wrapperPosition = 57;
        }
        $(".component-secondary-navigation .mobile-opener").css("top", openerPosition + "px");
        $(".component-secondary-navigation .menu-wrapper").css("top", wrapperPosition + "px");
    });

    var menus = $(".component-secondary-navigation");
    if (menus.length) {
        $(".component-header ").addClass("no-shadow");
    }

    // Trigger the appropriate secondary nav accordion section to open if this is a second-level page that would otherwise be hidden due to the accordion starting out collapsed on page load.  This ensures the current, active second-level page always starts out visible in the secondary navigation.
    var $secondaryNavActiveLink = $("#secondary-menu .active");
    if ($secondaryNavActiveLink.length > 0) {
        var $activeLinkParentList = $secondaryNavActiveLink.parents(".level-two");
        if ($activeLinkParentList.length > 0) {
            var $activeLinkParentLink = $activeLinkParentList.parent().find(".opener");
            $activeLinkParentLink.trigger("click");
        }
    }

});